/* Buy replaces earlier Traceform previews while preserving other products. */
(function () {
  'use strict';
  function json(response) {
    if (!response.ok) throw new Error('cart');
    return response.json();
  }
  window.TraceformBuy = {
    hasEntitlement: function (token) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(json).then(function (cart) {
        return cart.items.some(function (line) { return line.properties && line.properties._entitlement === token; });
      });
    },
    replace: function (items, variantIds) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      return fetch(root + 'cart.js', { headers: headers, cache: 'no-store' }).then(json).then(function (cart) {
        var updates = {};
        cart.items.forEach(function (line) {
          var properties = line.properties || {};
          if (variantIds.map(Number).indexOf(Number(line.variant_id || line.id)) !== -1 ||
              /^tf-/.test(line.sku || '') || properties._entitlement || properties._course) {
            updates[line.key] = 0;
          }
        });
        if (!Object.keys(updates).length) return;
        return fetch(root + 'cart/update.js', {
          method: 'POST', headers: headers, body: JSON.stringify({ updates: updates })
        }).then(json);
      }).then(function () {
        return fetch(root + 'cart/add', {
          method: 'POST', headers: headers, body: JSON.stringify({ items: items })
        }).then(json);
      });
    }
  };
})();
